/** Shared product vocabulary. User-authored content is never translated here. */
export const japanese = {
  '交汇地': '交差点',
  '交汇地首页': '交差点のホーム',
  '交汇地全局导航': '交差点のナビゲーション',
  '交汇地主导航': '交差点のメインナビゲーション',
  '发现': '見つける',
  '关注': 'フォロー中',
  '切换信息流': 'フィードを切り替える',
  '切换信息流，当前：{name}': 'フィードを切り替える：現在は{name}',
  '营地': 'キャンプ',
  '返回营地': 'キャンプに戻る',
  '兔子洞': 'うさぎの穴',
  '关闭兔子洞': 'うさぎの穴を閉じる',
  '公告栏': '掲示板',
  '创作': 'つくる',
  '购物袋': 'バッグ',
  '客服': 'サポート',
  '更多入口': 'その他',
  '工房': '工房',
  '工房导航': '工房のナビゲーション',
  '当前系列': 'このシリーズ',
  '系列栏目': 'シリーズのメニュー',
  '选择系列': 'シリーズを選択',
  '系列：{name}': 'シリーズ：{name}',
  '未开发': '近日公開',
  '前往系列': 'シリーズへ',
  '在工房编辑': '工房で編集',
  '当前页面': '現在のページ',
  '前往': '移動',
  '内容': 'コンテンツ',
  '搜索“{query}”': '「{query}」を検索',
  '指令面板': 'コマンドメニュー',
  '前往页面、查找内容或执行操作…': 'ページやコンテンツを検索、操作を実行…',
  '查找指令或内容': 'コマンドやコンテンツを検索',
  '关闭指令面板': 'コマンドメニューを閉じる',
  '可用指令': '利用できるコマンド',
  '↑ ↓ 选择': '↑ ↓ 選択',
  'Enter 打开': 'Enter 開く',
  'Esc 关闭': 'Esc 閉じる',
  '先建一个系列收好故事，也可以直接去工房动手。': '物語を収めるシリーズをつくるか、工房で制作を始めましょう。',
  '带我做一遍 →': '使い方を見る →',
  '登录后即可开始创作。': 'ログインして制作を始めましょう。',
  '暂时无法完成，请重试。': '処理できませんでした。もう一度お試しください。',
  '连接超时，请重试。': '接続がタイムアウトしました。もう一度お試しください。',
  '请求超时，请重试。': 'リクエストがタイムアウトしました。もう一度お試しください。',
  '未命名系列': '名前のないシリーズ',
  '创建系列': 'シリーズをつくる',
  '系列已创建': 'シリーズを作成しました',
  '返回上一步': '戻る',
  '关闭创作': '閉じる',
  '正在读取…': '読み込み中…',
  '重试': '再試行',
  '登录': 'ログイン',
  '发布作品': '作品を公開',
  '发布周边': 'グッズを公開',
  '上传并公开作品': '作品をアップロードして公開',
  '从设计开始': 'デザインから始める',
  '管理作品与周边': '作品とグッズを管理',
  '选择作品的归属与来源': '作品の所属先と出典を選択',
  '做周边': 'グッズをつくる',
  '选择素材，进入周边设计': '素材を選んでグッズ制作台へ',
  '开始自己的世界': '自分の世界を始める',
  '系列名称': 'シリーズの名前',
  '取消': 'キャンセル',
  '正在创建…': '作成中…',
  '进入系列': 'シリーズを開く',
  '粘贴坐标或朋友分享的内容，即可到达。': 'シリーズのアドレスや共有されたリンクを貼り付けて移動できます。',
  '系列坐标': 'シリーズのアドレス',
  '粘贴系列坐标': 'シリーズのアドレスを貼り付け',
  '寻找中…': '検索中…',
  '进入': '開く',
  '没有找到可访问的系列，请检查坐标。': 'アクセスできるシリーズが見つかりません。アドレスをご確認ください。',
  '入口暂时无法连接，请重试。': '現在接続できません。もう一度お試しください。',
  '{name} 全局工具栏': '{name}のツールバー',
  '返回 {name}': '{name}に戻る',
  '头像与档案': 'アバターとプロフィール',
  '关闭{title}': '{title}を閉じる',
  '正在连接资料服务': 'プロフィールに接続中…',
  '资料暂时无法加载': 'プロフィールを読み込めません。',
  '账户菜单': 'アカウントメニュー',
  '我的账户': 'マイアカウント',
  '个人资料': 'プロフィール',
  '魔素': 'マナ',
  '魔素与用量': 'マナと使用量',
  '个人事务': '設定',
  '外观': '表示設定',
  '退出登录': 'ログアウト',
  '正在退出…': 'ログアウト中…',
  '退出失败，请稍后重试': 'ログアウトできませんでした。もう一度お試しください。',
  '切换为简体中文': '簡体字中国語に切り替える',
  '语言': '言語',
};
